import { PimResource } from "./pim-resource.js";
import * as PIM from "../pim-vocabulary.js";
/**
 * Specify one end of the association that points to a data type definition,
 * most likely a class.
 */
export class PimAssociationEnd extends PimResource {
    static TYPE = PIM.ASSOCIATION_END;
    pimPart = null;
    pimCardinalityMin = null;
    pimCardinalityMax = null;
    constructor(iri = null) {
        super(iri);
        this.types.push(PimAssociationEnd.TYPE);
    }
    static is(resource) {
        return resource?.types.includes(PimAssociationEnd.TYPE);
    }
}
//# sourceMappingURL=pim-association-end.js.map